import angular from 'angular';
import { IScope } from 'angular';
import { FilterService2 } from '../../tn.common';
import { LocalProjects } from '../local-projects.service/localProjects';

ProjectsIndexSidebar.$inject = [
    'localProjects',
    'tn.projects.filters.service',
    '$scope',
];

export function ProjectsIndexSidebar(
    localProjects: LocalProjects,
    projectFilters: FilterService2,
    $scope: IScope
): void {
    angular.extend(this, {
        activeFilters: projectFilters.get(),
        toggleFilter: (name, obj) => projectFilters.toggle(name, obj),
        clearFilter: (name) => projectFilters.reset(name),
        clearFilters: () => projectFilters.resetAll(),
        hasFilter: (name, value) => projectFilters.hasFilter(name, value),
        isActive: { date: true },
        filteredProjects: localProjects.getFilteredSummaries(),
        currentDate: new Date(),
    });

    initialize();

    function initialize() {
        $scope.$watch(
            'vm.activeFilters',
            function (newFilters) {
                localProjects.setFilters(newFilters);
            },
            true
        );
    }
}
